const DATE_FORMAT_WITH_TIME = 'MM/DD/YYYY HH:mm A';
const DATE_FORMAT_WITHOUT_TIME = 'MM/DD/YYYY';

export { DATE_FORMAT_WITH_TIME, DATE_FORMAT_WITHOUT_TIME };
